import './SuccessMessage.scss';

import { ButtonV2 } from '@travelwin/core';

import checkCircleImage from '../../assets/check-circle.svg';

const className = 'c-SuccessMessage';

interface Props {
  title: string;
  description: string;
  buttonText: string;
  buttonDataTestId: string;
  onButtonClick: () => void;
}

const SuccessMessage = ({
  title,
  description,
  buttonText,
  buttonDataTestId,
  onButtonClick,
}: Props) => {
  return (
    <div className={`${className}__content`}>
      <div className={`${className}__content-item-center`}>
        <h1 className={`${className}__title`}>{title}</h1>
        <img alt="esim" src={checkCircleImage} role="presentation" />
        <p className={`${className}__description`}>{description}</p>
      </div>
      <div className={`${className}__content-item`}>
        <ButtonV2
          size="large"
          variant="primary"
          style={{
            boxShadow: '0px 5px 10px 0px #00000020',
          }}
          fluid
          onClick={onButtonClick}
          data-testid={buttonDataTestId}
        >
          {buttonText}
        </ButtonV2>
      </div>
    </div>
  );
};
export default SuccessMessage;
